import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy URL: `/auth/signin` → `/auth/login`. */
export const Route = createFileRoute("/auth/signin")({
  beforeLoad: () => {
    throw redirect({ to: "/auth/login", replace: true });
  },
});
